<div mat-dialog-title style="margin: 0;">
    <span>
        Student In Focus
    </span>
</div>

<mat-dialog-content>
    <div style="text-align:center;">
        <student-name [firstName]="student.FirstName" [lastName]="student.LastName" [middleName]="student.MiddleName" [nickName]="student.NickName"></student-name>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <tyl-button id="focusClearButton" image="undo.png" label="Clear" (clickEvent)="clearFocus()"></tyl-button>
    <div class="flex-footer-right">
        <tyl-button id="focusCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>